import ApiService from '@/services/ApiService';

const apiService = new ApiService();

const get = function () {
    return apiService.get('session');
}

const getByUserId = function (userId) {
    return apiService.get('session', `user/${userId}`);
}

const create = function (data) {
    return apiService.post('session', data);
}

const update = function (data) {
    return apiService.put('session', data);
}

export default {
    get,
    getByUserId,
    create,
    update
}